import { render, staticRenderFns } from "./CalendarItem.vue?vue&type=template&id=024bdf1a&"
import script from "./CalendarItem.vue?vue&type=script&lang=js&"
export * from "./CalendarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports